// import fun
import Layout from '@/page/layout'
// import fun
const _import = require('../_import')
// scope rent
const scope = 'rent'

export default {
    path: '/rent',
    name: 'rent',
    component: Layout,
    // component: _import(`layout`),
    meta: {title: '租赁管理', icon: ''},
    redirect: '/rent/lease',
    children: [
      {
        path: '/',
        name: 'rent-layout',
        component: _import(`${scope}/Layout`),
        children: [

          {
            path: 'lease',
            name: 'lease',
            component: _import(`${scope}/lease`),
            meta: {title: '出租管理', icon: ''}
          },
          {
            path: 'rent1',
            name: 'rent1',
            component: _import(`${scope}/rent1`),
            meta: {title: '预约看房', icon: ''}
          },
          {
            path: 'reserveHouse',
            name: 'reserveHouse',
            component: _import(`${scope}/reserveHouse`),
            meta: {title: '预定房源', icon: ''}
          },
          {
            path: 'sublet',
            name: 'sublet',
            component: _import(`${scope}/sublet`),
            meta: {title: '转租管理', icon: ''}
          },
          {
            path: 'contract',
            name: 'contract',
            component: _import(`${scope}/contract`),
            meta: {title: '租客合同', icon: ''}
          },
          {
            path: 'cancelRent',
            name: 'cancelRent',
            component: _import(`${scope}/cancelRent`),
            meta: {title: '退租管理', icon: ''}
          },
          {
            path: 'renew',
            name: 'renew',
            component: _import(`${scope}/renew`),
            meta: {title: '续租管理', icon: ''}
          },
          {
            path: 'changeHouse',
            name: 'changeHouse',
            component: _import(`${scope}/changeHouse`),
            meta: {title: '换房管理', icon: ''}
          },
          {
            path: 'enterprise-contract',
            name: 'enterprise-contract',
            component: _import(`${scope}/enterprise-contract/index`),
            meta: {title: '企业出租', icon: ''}
          },
          {
            path: 'enterprise-list',
            name: 'enterprise-list',
            component: _import(`${scope}/enterprise-list/index`),
            meta: {title: '企业信息', icon: ''}
          },
        ]
      }
    ]
}



// WEBPACK FOOTER //
// ./src/router/modules/rent.js